import React, { useState, useEffect, useRef } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  updateProductServ,
  getProductDetailsServ,
  getProductServ,
} from "../../services/product.services";
import { getTagSetServ } from "../../services/tag.service";
import { getProductTypeServ } from "../../services/productType.service";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from "jodit-react";
import { useParams, useNavigate } from "react-router-dom";
import { getBrandServ } from "../../services/brand.services";
import Select from "react-select";
import { getCategoryServ } from "../../services/category.service";

function ProductUpdateStep1() {
  const descriptionRef = useRef("");
  const [description, setDescription] = useState("");
  const params = useParams();
  const navigate = useNavigate();
  const editor = useRef(null);
  const contentRef = useRef("");
  const [btnLoader, setBtnLoader] = useState(false);
  const [content, setContent] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    brandId: "",
    tags: [],
    productType: "",
    categoryId: [],
    hsnCode: "",
    GTIN: "",
    shortDescription: "",
    productApperence: "",
    description: "",
    slug:""
  });
  const [brandList, setBrandList] = useState([]);
  const getBrandList = async () => {
    try {
      let response = await getBrandServ({ status: true });
      if (response?.data?.statusCode == "200") {
        setBrandList(response?.data?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getBrandList();
  }, []);
  const [tagOptions, setTagOptions] = useState([]);
  const [productTypeOptions, setProductTypeOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);

  const config = {
    placeholder: "Start typing...",
    height: "300px",
  };

  const fetchDropdownData = async () => {
    try {
      const [tagRes, typeRes, categoryRes] = await Promise.all([
        getTagSetServ({ status: true }),
        getProductTypeServ({ status: true }),
        getCategoryServ({ status: true }),
      ]);

      if (tagRes?.data?.statusCode == 200) {
        setTagOptions(
          tagRes.data.data.map((tag) => ({ label: tag.name, value: tag.name }))
        );
      }
      if (typeRes?.data?.statusCode == 200) {
        setProductTypeOptions(
          typeRes.data.data.map((type) => ({
            label: type.name,
            value: type.name,
          }))
        );
      }

      if (categoryRes?.data?.statusCode == 200) {
        setCategoryOptions(
          categoryRes.data.data.map((category) => ({
            label: category.name,
            value: category._id,
          }))
        );
      }
    } catch (error) {
      toast.error("Failed to fetch dropdown data.");
    }
  };

  const getProductDetails = async () => {
    try {
      let response = await getProductDetailsServ(params?.id);
      if (response?.data?.statusCode == 200) {
        const product = response?.data?.data?.product;
        setFormData({
          name: product?.name || "",
          tags: product?.tags || [],
          slug: product?.slug || "",
          productType: product?.productType || "",
          brandId: product?.brandId?._id || "",
          categoryId: product?.categoryId?.map((v) => v._id) || [],
          productApperence: product?.productApperence || "",
          hsnCode: product?.hsnCode || "",
          GTIN: product?.GTIN || "",
          shortDescription: product?.shortDescription || "",
          description: product?.description || "",
          description: product?.slug || "",
        });
        setContent(product?.shortDescription || "");
        contentRef.current = product?.shortDescription || "";
        setDescription(product?.description || "");
        descriptionRef.current = product?.description || "";
      }
    } catch (error) {
      toast.error("Failed to fetch product details.");
    }
  };

  useEffect(() => {
    fetchDropdownData();
    getProductDetails();
  }, []);

  const [slugError, setSlugError] = useState("");

  // slug pehle se to nahi hai — live check (khud ko chhod ke)
  const checkSlugUnique = async () => {
    const slug = (formData?.slug || "").trim();
    if (!slug) {
      setSlugError("");
      return;
    }
    try {
      const listRes = await getProductServ({ pageNo: 1, pageCount: 100000 });
      const list = listRes?.data?.data || [];
      const duplicate = list.find(
        (p) =>
          (p?.slug || "").trim().toLowerCase() === slug.toLowerCase() &&
          p?._id !== params?.id
      );
      setSlugError(
        duplicate ? "This slug already exists. Please use a unique slug." : ""
      );
    } catch (e) {}
  };

  const updateProductFunc = async () => {
    setBtnLoader(true);
    try {
      // slug required + unique (khud ko chhod ke)
      const slug = (formData?.slug || "").trim();
      if (!slug) {
        toast.error("Slug is required");
        setBtnLoader(false);
        return;
      }
      try {
        const listRes = await getProductServ({ pageNo: 1, pageCount: 100000 });
        const list = listRes?.data?.data || [];
        const duplicate = list.find(
          (p) =>
            (p?.slug || "").trim().toLowerCase() === slug.toLowerCase() &&
            p?._id !== params?.id
        );
        if (duplicate) {
          setSlugError("This slug already exists. Please use a unique slug.");
          toast.error("This slug already exists. Please use a unique slug.");
          setBtnLoader(false);
          return;
        }
      } catch (e) {
        // list fail ho to backend check pe chhod do
      }

      let updatedData = {
        ...formData,
        shortDescription: contentRef.current,
        description: descriptionRef.current,
        id: params?.id,
      };
      let response = await updateProductServ(updatedData);
      if (response?.data?.statusCode == 200) {
        toast.success(response?.data?.message);
        setFormData({
          name: "",
          tags: [],
          productType: "",
          categoryId: [],
          productApperence: "",
          hsnCode: "",
          GTIN: "",
          brandId: "",
          shortDescription: "",
          description: "",
          slug:""
        });
        navigate("/update-product-step2/" + response?.data?.data?._id);
      } else {
        toast.error("Something went wrong");
      }
    } catch (error) {
      toast.error("Internal Server Error");
    }
    setBtnLoader(false);
  };

  return (
    <div className="bodyContainer">
      <Sidebar selectedMenu="Product Management" selectedItem="" />
      <div className="mainContainer">
        <TopNav />
        <div className="p-lg-4 p-md-3 p-2">
          <div
            className="row mx-0 p-0"
            style={{
              position: "relative",
              top: "-75px",
              marginBottom: "-75px",
            }}
          ></div>

          <div className="mt-3">
            <div className="card-body px-2">
              <div className="d-flex">
                <h4
                  className="p-2 text-dark shadow rounded mb-4"
                  style={{ background: "#05E2B5" }}
                >
                  Update Product : Step 1/4
                </h4>
              </div>
              <div className="row">
                <div className="col-6 mb-3">
                  <label>Name</label>
                  <input
                    type="text"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                    className="form-control"
                  />
                </div>
                <div className="col-6 mb-3">
                  <label>
                    Slug<span className="text-danger"> *</span>
                  </label>
                  <input
                    type="text"
                    value={formData.slug}
                    onChange={(e) => {
                      setFormData({ ...formData, slug: e.target.value });
                      setSlugError("");
                    }}
                    onBlur={checkSlugUnique}
                    className={`form-control ${slugError ? "is-invalid" : ""}`}
                    placeholder="e.g. magical-masala-makhana"
                  />
                  <small className="text-danger">
                    {slugError ? slugError : "Slug must be unique"}
                  </small>
                </div>

                <div className="col-4 mb-3">
                  <label>Category</label>
                  <Select
                    isMulti
                    value={categoryOptions.filter((option) =>
                      formData.categoryId.includes(option.value)
                    )}
                    onChange={(selected) =>
                      setFormData({
                        ...formData,
                        categoryId: selected.map((option) => option.value),
                      })
                    }
                    options={categoryOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                  />
                </div>
                <div className="col-4 mb-3">
                  <label>Brand</label>
                  <select
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        brandId: e?.target.value,
                      })
                    }
                    value={formData?.brandId}
                    className="form-control"
                  >
                    <option value="">Select</option>
                    {brandList?.map((v, i) => {
                      return <option value={v?._id}>{v?.name}</option>;
                    })}
                  </select>
                </div>
                <div className="col-4 mb-3">
                  <label>Product Type</label>
                  <Select
                    value={
                      formData.productType
                        ? {
                            label: formData.productType,
                            value: formData.productType,
                          }
                        : null
                    }
                    onChange={(selected) =>
                      setFormData({
                        ...formData,
                        productType: selected?.value || "",
                      })
                    }
                    options={productTypeOptions}
                  />
                </div>
                <div className="col-6 mb-3">
                  <label>Tags</label>
                  <Select
                    isMulti
                    value={formData.tags.map((tag) => ({
                      label: tag,
                      value: tag,
                    }))}
                    onChange={(selected) =>
                      setFormData({
                        ...formData,
                        tags: selected.map((option) => option.value),
                      })
                    }
                    options={tagOptions}
                  />
                </div>
                <div className="col-6 mb-3">
                  <label>Special Apperence</label>
                  <select
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        productApperence: e?.target?.value,
                      })
                    }
                    value={formData?.productApperence}
                    className="form-control"
                  >
                    <option>Select</option>
                    <option>Popular</option>
                    <option>Best Seller</option>
                    <option>Daily Best Sell</option>
                  </select>
                </div>

                <div className="col-6 mb-3">
                  <label>HSN Code</label>
                  <input
                    className={`form-control`}
                    style={{ height: "45px" }}
                    value={formData?.hsnCode}
                    onChange={(e) => {
                      setFormData({ ...formData, hsnCode: e?.target?.value });
                    }}
                  />
                </div>

                <div className="col-6 mb-3">
                  <label>GTIN Code</label>
                  <input
                    className="form-control"
                    style={{ height: "45px" }}
                    value={formData?.GTIN || ""}
                    type="number"
                    required
                    onChange={(e) => {
                      setFormData({ ...formData, GTIN: e?.target?.value });
                    }}
                  />
                </div>

                <div className="col-12 mb-3">
                  <label>Short Description</label>
                  <JoditEditor
                    ref={editor}
                    config={config}
                    value={content}
                    onChange={(newContent) => {
                      contentRef.current = newContent;
                    }}
                  />
                </div>
                <div className="col-12 mb-3">
                  <label>Product Description</label>
                  <JoditEditor
                    ref={editor}
                    config={config}
                    value={description}
                    onChange={(newContent) => {
                      descriptionRef.current = newContent;
                    }}
                  />
                </div>

                <div className="col-12">
                  <button
                    className="btn btn-primary w-100"
                    style={{
                      background: "#61ce70",
                      border: "none",
                      borderRadius: "24px",
                    }}
                    onClick={updateProductFunc}
                    disabled={btnLoader}
                  >
                    {btnLoader ? "Saving..." : "Update & Continue"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductUpdateStep1;
